/* BP Motors · ficha de vehículo: cabecera, galería 3D de fotos y visor */
(function () {
  'use strict';
  var root = document.querySelector('.fx');
  if (!root) return;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var D = { images: [] };
  try { D = JSON.parse($('#fx-data').textContent); } catch (e) {}
  var imgs = D.images || [];
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  /* ---------- Cabecera ---------- */
  var burger = $('#burger'), mnav = $('#mnav'), top = $('.top');
  function setMenu(open) {
    mnav.hidden = !open;
    burger.setAttribute('aria-expanded', open);
    burger.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
    document.body.style.overflow = open ? 'hidden' : '';
  }
  burger.addEventListener('click', function () { setMenu(mnav.hidden); });
  mnav.addEventListener('click', function (e) { if (e.target.closest('a')) setMenu(false); });
  addEventListener('keydown', function (e) { if (e.key === 'Escape' && !mnav.hidden) { setMenu(false); burger.focus(); } });
  var lastY = 0;
  addEventListener('scroll', function () {
    var y = scrollY;
    top.classList.toggle('hide', y > lastY + 2 && y > 180 && mnav.hidden);
    if (y < lastY - 2 || y <= 180) top.classList.remove('hide');
    lastY = y;
  }, { passive: true });
  var nav = $('#nav'), ind = $('.ind', nav), curLink = $('a[aria-current]', nav);
  function moveInd() {
    if (!curLink || !ind) return;
    var r = curLink.getBoundingClientRect(), n = nav.getBoundingClientRect();
    ind.style.width = r.width + 'px';
    ind.style.transform = 'translateX(' + (r.left - n.left) + 'px)';
    ind.style.opacity = 1;
  }
  moveInd();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(moveInd);
  addEventListener('resize', moveInd);

  /* ---------- Aparición al hacer scroll ---------- */
  var rv = $$('.fx-rv,.fx-specs');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('fx-in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    rv.forEach(function (n) { io.observe(n); });
    setTimeout(function () { rv.forEach(function (n) { n.classList.add('fx-in'); }); }, 9000);
  } else {
    rv.forEach(function (n) { n.classList.add('fx-in'); });
  }

  /* ---------- Galería 3D de fotos reales ---------- */
  var flow = $('#fx-flow'), thumbsEl = $('#fx-thumbs'), filtersEl = $('#fx-filters');
  var cnt = $('#fx-count'), cap = $('#fx-cap'), lb = $('#fx-lb'), lbi = $('#fx-lbimg');
  if (!flow || !imgs.length) return;
  var reMec = /motor|vano|equipo|evaporador|condensador|atp|cuadro|anagrama|refrigerante|llanta|neum[aá]tico|enganche/i;
  var reInt = /cabina|puesto|conductor|copiloto|asiento|salpicadero|interior|caja|acceso lateral|contrapuerta|cierres|volante|pantalla|mandos|selector|maletero|usb|plazas/i;
  imgs.forEach(function (m) {
    if (m.g) return;
    var a = m.a || '', part = a.indexOf('—') > -1 ? a.split('—').slice(1).join('—') : a;
    m.g = reMec.test(part) ? 'mec' : (reInt.test(part) ? 'int' : 'ext');
  });
  var names = { ext: 'Exterior', int: 'Interior', mec: 'Mecánica' };
  var groups = { all: imgs.length };
  imgs.forEach(function (m) { groups[m.g] = (groups[m.g] || 0) + 1; });
  var cards = [], ths = [], vis = [], idx = 0, moved = 0;
  var narrow = function () { return innerWidth < 700; };

  function ensure(i) {
    var im = cards[i] && cards[i].firstChild;
    if (im && !im.getAttribute('src')) im.src = im.dataset.src;
  }
  imgs.forEach(function (m, i) {
    var c = document.createElement('button');
    c.type = 'button';
    c.className = 'fx-card';
    c.setAttribute('aria-label', 'Foto ' + (i + 1) + ': ' + m.a);
    c.style.setProperty('--bg', 'url("' + m.t + '")');
    var im = document.createElement('img');
    im.alt = '';
    im.decoding = 'async';
    im.draggable = false;
    im.dataset.src = m.s;
    c.appendChild(im);
    c.addEventListener('click', function () {
      if (moved > 6) return;
      if (i === idx) openLb(); else go(i);
    });
    flow.appendChild(c);
    cards.push(c);
    var t = document.createElement('button');
    t.type = 'button';
    t.className = 'fx-th';
    t.setAttribute('aria-label', 'Ver foto ' + (i + 1));
    var ti = document.createElement('img');
    ti.src = m.t; ti.alt = ''; ti.loading = 'lazy'; ti.width = 96; ti.height = 72;
    t.appendChild(ti);
    t.addEventListener('click', function () { go(i); });
    thumbsEl.appendChild(t);
    ths.push(t);
  });

  function layout() {
    var pos = vis.indexOf(idx), nar = narrow();
    cards.forEach(function (c, i) {
      var p = vis.indexOf(i);
      if (p < 0) { c.style.display = 'none'; return; }
      c.style.display = '';
      var d = p - pos, ad = Math.abs(d), sg = d < 0 ? -1 : 1;
      if (ad > 3) {
        c.style.visibility = 'hidden';
        c.style.pointerEvents = 'none';
        c.style.opacity = 0;
        c.style.transform = 'translate(-50%,-50%) translate3d(' + sg * 110 + '%,0,-520px)';
        return;
      }
      c.style.visibility = '';
      c.style.pointerEvents = '';
      var x = d === 0 ? 0 : sg * ((nar ? 44 : 58) + (ad - 1) * (nar ? 14 : 20));
      var z = -ad * 150 - (ad ? 40 : 0);
      var r = d === 0 ? 0 : -sg * Math.min(52, 34 + ad * 6);
      c.style.transform = 'translate(-50%,-50%) translate3d(' + x + '%,0,' + z + 'px) rotateY(' + r + 'deg)';
      c.style.opacity = ad === 0 ? 1 : (ad === 1 ? 0.9 : (ad === 2 ? 0.6 : 0.3));
      c.style.zIndex = 100 - ad * 10;
      c.style.setProperty('--dim', ad === 0 ? 0 : Math.min(0.6, 0.2 + ad * 0.15));
      c.setAttribute('aria-current', d === 0 ? 'true' : 'false');
      if (ad <= 2) ensure(i);
    });
    cnt.textContent = pad(pos + 1) + ' / ' + pad(vis.length);
    cap.textContent = imgs[idx].a;
    ths.forEach(function (t, i) { t.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
    var th = ths[idx];
    if (th && thumbsEl.scrollTo) thumbsEl.scrollTo({ left: th.offsetLeft - thumbsEl.clientWidth / 2 + th.offsetWidth / 2, behavior: reduce ? 'auto' : 'smooth' });
    if (lb.classList.contains('on')) { lbi.src = imgs[idx].s; lbi.alt = imgs[idx].a; }
  }
  function go(i) { idx = i; layout(); }
  function step(d) { go(vis[(vis.indexOf(idx) + d + vis.length) % vis.length]); }
  function setFilter(k) {
    vis = [];
    imgs.forEach(function (m, i) { if (k === 'all' || m.g === k) vis.push(i); });
    ths.forEach(function (t, i) { t.hidden = vis.indexOf(i) < 0; });
    if (vis.indexOf(idx) < 0) idx = vis[0];
    $$('button', filtersEl).forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.k === k); });
    layout();
  }

  var keys = ['all', 'ext', 'int', 'mec'].filter(function (k) { return groups[k]; });
  if (keys.length > 2) {
    keys.forEach(function (k) {
      var b = document.createElement('button');
      b.type = 'button';
      b.dataset.k = k;
      b.textContent = k === 'all' ? 'Todas' : names[k];
      var n = document.createElement('i');
      n.textContent = groups[k];
      b.appendChild(n);
      b.addEventListener('click', function () { setFilter(k); });
      filtersEl.appendChild(b);
    });
  }

  var sx = null;
  flow.addEventListener('pointerdown', function (e) {
    if (e.button > 0) return;
    sx = e.clientX; moved = 0;
    flow.classList.add('drag');
  });
  flow.addEventListener('pointermove', function (e) {
    if (sx === null) return;
    var dx = e.clientX - sx;
    moved = Math.max(moved, Math.abs(dx));
    if (Math.abs(dx) > 70) { step(dx < 0 ? 1 : -1); sx = e.clientX; }
  });
  function endDrag() { sx = null; flow.classList.remove('drag'); setTimeout(function () { moved = 0; }, 0); }
  flow.addEventListener('pointerup', endDrag);
  flow.addEventListener('pointercancel', endDrag);
  flow.addEventListener('pointerleave', function () { if (sx !== null) endDrag(); });
  flow.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') { step(-1); e.preventDefault(); }
    if (e.key === 'ArrowRight') { step(1); e.preventDefault(); }
    if (e.key === 'Enter') openLb();
  });
  $('#fx-prev').addEventListener('click', function () { step(-1); });
  $('#fx-next').addEventListener('click', function () { step(1); });
  addEventListener('resize', layout);

  function openLb() {
    lb.classList.add('on');
    lbi.src = imgs[idx].s;
    lbi.alt = imgs[idx].a;
    document.documentElement.style.overflow = 'hidden';
    $('.x', lb).focus();
  }
  function closeLb() { lb.classList.remove('on'); document.documentElement.style.overflow = ''; }
  $('.x', lb).addEventListener('click', closeLb);
  $('.lp', lb).addEventListener('click', function () { step(-1); });
  $('.ln', lb).addEventListener('click', function () { step(1); });
  lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
  addEventListener('keydown', function (e) {
    if (!lb.classList.contains('on')) return;
    if (e.key === 'Escape') closeLb();
    if (e.key === 'ArrowLeft') step(-1);
    if (e.key === 'ArrowRight') step(1);
  });
  setFilter('all');
})();